import React, { useEffect, useState } from 'react';

import { useRegistrationFrequentPassageRequests } from '../../../hooks/api/frequent-passage-requests/useRegistrationFrequentPassageRequests';
import { Registration } from '../../../hooks/api/utils/types';
import { useFilterQuery } from '../../../hooks/useFilterQuery';
import { useEvent } from '../../../providers/event';
import FrequentPassageRequestsListView from '../../shared/frequentPassageRequests/FrequentPassageRequestsListView';
import CreateFrequentPassageRequestButton from './CreateFrequentPassageRequestButton';

type Props = {
  registration: Registration;
  admin: boolean;
};

export default function RegistrationFrequentPassageRequests({ registration, admin }: Props) {
  const event = useEvent();
  const filters = useFilterQuery();
  const [listFilters, setListFilters] = useState<Record<string, any>>(filters);

  const { data, isLoading, refetch } = useRegistrationFrequentPassageRequests(registration.id, {
    ...listFilters,
    // ...filters,
  });

  useEffect(() => {
    refetch();
  }, [listFilters]);

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title" />
              </div>

              <div className="m-portlet__head-tools">
                <ul className="m-portlet__nav m--margin-left-20">
                  {registration.frequentPassageRequestsAllowed && (
                    <li className="m-portlet__nav-item">
                      <CreateFrequentPassageRequestButton registration={registration} />
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          {isLoading && <div className="alert alert-info">Loading...</div>}

          {data && event && (
            <FrequentPassageRequestsListView
              registration={registration}
              event={event}
              onFiltersChange={setListFilters}
              filters={listFilters}
              admin={admin}
              data={data}
              refetch={refetch}
            />
          )}
        </div>
      </div>
    </>
  );
}
